import type { OrButtonSize, OrButtonTheme, OrButtonVariant } from './or-button';

export interface UseOrButtonParams {
  className?: string;
  fullWidth?: boolean;
  size?: OrButtonSize;
  theme?: OrButtonTheme;
  variant?: OrButtonVariant;
}

export interface UseOrButtonResult {
  buttonClassName: string;
}

export function useOrButton({
  className,
  fullWidth = false,
  size = 'md',
  theme = 'default',
  variant = 'primary',
}: UseOrButtonParams): UseOrButtonResult {
  const classes = [
    'or-button',
    `or-button--${variant}`,
    `or-button--${size}`,
    theme === 'social' ? 'or-button--social' : '',
    fullWidth ? 'or-button--full-width' : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');

  return {
    buttonClassName: classes,
  };
}
